var addEanPrefix = function (ean) {
    var prefixedEan = ean;
    if (ean.charAt(0) !== "*") {
        prefixedEan = "*" + ean;
    }
    return prefixedEan;
};
export default addEanPrefix;
